import React, {useMemo} from "react";
import {TerminalReleaseState} from "~/apps/packages/warehouse-closure/queries";
import {getTerminalReleaseStatusColor, humanizeTerminalReleaseState} from "~/apps/packages/warehouse-closure/utils";
import {StatusBadge, StatusBadgeProps} from "~/apps/core/ui/StatusBadge";


export type TerminalReleaseStatusBadgeProps = Omit<StatusBadgeProps<TerminalReleaseState>, "badgeColor">;


export const TerminalReleaseStatusBadge = (props: TerminalReleaseStatusBadgeProps) => {
    const {children, ...otherProps} = props;
    const status = useMemo(() => humanizeTerminalReleaseState(children), [children]);
    const badgeColor = useMemo(() => getTerminalReleaseStatusColor(children), [status]);

    if (!status) {
        return null;
    }

    return (
        <StatusBadge {...otherProps} badgeColor={badgeColor} outlined={false} variant="cardText">
            {status}
        </StatusBadge>
    );
}